import { motion } from "framer-motion";

// Masked line reveal — wrap a single line of text
export const MaskLine = ({ children, delay = 0, className = "", mount = false }) => {
  const anim = mount
    ? { animate: { y: 0 } }
    : { whileInView: { y: 0 }, viewport: { once: true, margin: "-10%" } };
  return (
    <span className="block overflow-hidden">
      <motion.span
        className={`block ${className}`}
        initial={{ y: "110%" }}
        {...anim}
        transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
};

// Simple fade-up on scroll
export const FadeUp = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-10%" }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, dark = false }) => (
  <div className="flex items-center gap-3 mb-6">
    <span className="h-px w-10 bg-flame" />
    <span
      className={`text-xs font-semibold uppercase tracking-[0.25em] ${
        dark ? "text-white/60" : "text-ink/50"
      }`}
    >
      {children}
    </span>
  </div>
);
